import { Chip } from '@/components/ui'
import type { CofaIdentity } from '../api/types'
import { cofaCheckLabel, type CofaCheckStatus } from '../utils/customer-cofa'

export function CofaIdentityChip({
  status,
  identity,
  sourceProblem = false,
  size = 'xs',
}: {
  status: CofaCheckStatus
  identity?: CofaIdentity
  sourceProblem?: boolean
  size?: 'xs' | 'md'
}) {
  const { label, variant } = cofaCheckLabel(status, identity, sourceProblem)
  return (
    <Chip size={size} variant={variant} dot title={identity?.reason ?? undefined}>
      {label}
    </Chip>
  )
}
